'use strict'

var regexCheck = require('../util/regex-check.js')

var asciiHexDigit = regexCheck(/[\dA-Fa-f]/)

module.exports = asciiHexDigit



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/character/ascii-hex-digit.js
// module id = 1503
// module chunks = 0